import {MessageCircleDashed as MessageCircle} from 'lucide-react'
import { WHATSAPP_LINK } from '@/lib/constants'

interface WhatsAppButtonProps {
  label?: string
  variant?: 'primary' | 'onDark' | 'outline'
  size?: 'md' | 'lg'
  className?: string
  showIcon?: boolean
}

function WhatsAppButton({
  label = 'Falar no WhatsApp',
  variant = 'primary',
  size = 'md',
  className = '',
  showIcon = true,
}: WhatsAppButtonProps) {
  const sizeClasses = size === 'lg'
    ? 'px-8 py-4 text-base sm:text-lg'
    : 'px-5 py-2.5 text-sm'

  const variantClasses = {
    primary: 'bg-blue-600 text-white hover:bg-blue-500 shadow-lg shadow-blue-600/25 hover:shadow-blue-500/35',
    onDark: 'bg-white text-blue-950 hover:bg-slate-100 shadow-lg shadow-black/10',
    outline: 'bg-transparent text-white border border-white/20 hover:bg-white/10 hover:border-white/35',
  }[variant]

  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-tight transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 ${sizeClasses} ${variantClasses} ${className}`}
    >
      {showIcon ? <MessageCircle className="w-4 h-4 shrink-0" strokeWidth={2.25} /> : null}
      {label}
    </a>
  )
}

export default WhatsAppButton
